import type { ClassNameProp } from '../common-types';
import React from 'react';

export interface QRCodeProps extends ClassNameProp {
  qrcodeSVG: string;
  width: number;
  height: number;
  ariaLabelledby?: string;
}

export function QRCode({
  className = '',
  qrcodeSVG,
  width,
  height,
  ariaLabelledby,
  ...props
}: Readonly<QRCodeProps>): React.JSX.Element {
  const iframeContent = `<html style="padding: 0; margin: 0;">
      <body style="padding: 0; margin: auto; overflow: hidden; text-align: center;">
          ${qrcodeSVG
            .replace(/width="[^"]+"/g, `width="${width}"`)
            .replace(/height="[^"]+"/g, `height="${height}"`)}
      </body>
    </html>`;

  return (
    <iframe
      {...props}
      srcDoc={iframeContent}
      sandbox={''}
      className={`ehs-qr-code ${className}`.trim()}
      aria-labelledby={ariaLabelledby}
      style={{
        width,
        height
      }}
    />
  );
}
